import { Component, inject } from '@angular/core';
import { BackendApi } from '../../services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AG_GRID_LOCALE_FR } from '@ag-grid-community/locale';
import { AgGridAngular } from "ag-grid-angular";
import type { AutoSizeStrategy, ColDef, GridReadyEvent } from "ag-grid-community";
import { Zone } from '../../models/zone';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-list-zones',
  imports: [AgGridAngular, MatIconModule],
  templateUrl: './list-zones.html',
  styleUrl: './list-zones.css',
})
export class ListZones {
  constructor(
    private readonly backendApi: BackendApi
  ) { }

  private _snackBar = inject(MatSnackBar);

  public autoSizeStrategy: AutoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  public localeText = AG_GRID_LOCALE_FR;

  public columns: ColDef<Zone>[] = [
    { field: "name", headerName: "Nom", filter: true, floatingFilter: true }
  ];

  onGridReady(event: GridReadyEvent) {
    this.backendApi.getZones().subscribe({
      next: (zones) => {
        event.api.setGridOption('loading', false);
        event.api.setGridOption('rowData', zones);
      },
      error: () => {
        // Error encountered
        event.api.setGridOption('loading', false);
        this._snackBar.open("Erreur rencontrée lors de la recuperation des zones.");
      }
    });
  }
}
